function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "2gghp8h10a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.011765 0 0 0 0 0.435294 0 0 0 0 0.886275 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-482 -461) translate(80 246) translate(0 169) translate(396 40) translate(6 6)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#47db99",
  d: "M2 4v16h12v2H2C.93 22 .055 21.157.002 20.1L0 20V4h2zm11.414-4L18 4.586V16c0 1.07-.843 1.945-1.9 1.998L16 18H6c-1.07 0-1.945-.843-1.998-1.9L4 16V2C4 .931 4.843.055 5.9.002L6 0h7.414zM12 2H6v14h10.001L16 6h-4V2z",
  transform: "translate(3 1)"
}))))))));

var SvgCopyIconGreen = function SvgCopyIconGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyIconGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copyIconGreen.6edf951f.svg";
export { ForwardRef as ReactComponent };